import FileRenamePopup from './FileRenamePopup';

export default FileRenamePopup;
